<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        Servicios o documentos
      </v-card-title>
      <v-card-text>
        <v-layout row justify-center align-center>
          <v-flex xs6 px-2>
            <v-layout row justify-center align-center>
              <v-flex xs12>
                <v-select
                  :items="services"
                  v-model="service"
                  label="Selecciona servicio o documento"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout mt-4 mb-4 row wrap justify-center align-center>
              <v-flex xs12>
                <div class="body-2">
                  {{ service_selected.description }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout row justify-center align-center>
              <v-flex xs12>
                <v-select
                  :items="students"
                  v-model="student"
                  label="¿ Quien utiliza el servicio ?"
                  v-validate="'required'"
                  data-vv-as="¿ Quien utiliza el servicio ?"
                  data-vv-name="student"
                  :error-messages="errors.collect('student')"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-card-text v-if="service_selected.id">
              <v-layout
                v-if="service_selected.handles_language"
                row
                justify-center
                align-center
              >
                <v-flex xs12>
                  <v-select
                    :items="languages"
                    v-model="handles_language"
                    label="¿En qué idioma requiere el certificado?"
                    v-validate="'required'"
                    data-vv-as="¿En qué idioma requiere el certificado?"
                    data-vv-name="handles_language"
                    :error-messages="errors.collect('handles_language')"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="service_selected.handles_format"
                row
                justify-center
                align-center
              >
                <v-flex xs12>
                  <v-select
                    :items="formats"
                    v-model="handles_format"
                    label="¿En qué formato requiere el certificado?"
                    v-validate="'required'"
                    data-vv-as="¿En qué formato requiere el certificado?"
                    data-vv-name="handles_format"
                    :error-messages="errors.collect('handles_format')"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout
                column
                wrap
                justify-center
                align-center
                v-if="service_selected.multiple_services"
              >
                <v-flex xs3>
                  <v-text-field
                    name="quantity"
                    label="Cantidad"
                    v-model="quantity"
                    v-validate="'required'"
                    type="number"
                    min="1"
                    :max="service_selected.max_services"
                    :error-messages="errors.collect('quantity')"
                    style="width: 180px"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="invalidQuantity">
                  <v-alert :value="true" type="info">
                    La cantidad seleccionada debe estar entre 1 y
                    {{ service_selected.max_services }}
                  </v-alert>
                </v-flex>
                <v-flex xs6 v-if="notAvailable">
                  <v-alert :value="true" type="info">
                    Solo hay {{ service_selected.available_services }} servicios
                    disponibles
                  </v-alert>
                </v-flex>
              </v-layout>
              <v-layout
                column
                wrap
                justify-center
                align-center
                v-if="service_selected.needs_payment"
              >
                <v-flex xs6 v-if="isInPortfolio">
                  <v-alert :value="true" type="info">
                    En el momento no es posible adquirir el servicio
                    seleccionado, por favor enviar un correo electrónico a
                    cartera@columbus.edu.co. Muchas gracias.
                  </v-alert>
                </v-flex>
                <v-flex class="mb-4 mt-4" xs6>
                  <span class="title">Precio: </span>
                  <v-chip class="title" color="secondary" text-color="white">
                    <v-avatar class="green darken-4">$</v-avatar>
                    {{ formatNumber(service_selected.total_price) }}
                  </v-chip>
                </v-flex>
                <v-flex xs6>
                  <!-- <v-btn :loading="loading_btn" :disabled="loading_btn || isInPortfolio" @click="payPse" color="primary">Pagar PSE</v-btn> -->
                  <v-btn
                    :loading="loading_btn"
                    :disabled="
                      loading_btn ||
                        isInPortfolio ||
                        invalidQuantity ||
                        notAvailable ||
                        !student
                    "
                    @click="payTc"
                    color="primary"
                    >Pagar</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center v-else>
                <v-btn
                  @click="getService"
                  :loading="loading_btn"
                  :disabled="invalidQuantity || notAvailable"
                  color="primary"
                  >Agregar</v-btn
                >
              </v-layout>
              <!-- <v-layout row wrap justify-end v-if="service_selected.has_next_step">
                <v-btn :disabled="!canGoToService" :to="service_selected.next_step" color="secondary">Ir</v-btn>
              </v-layout> -->
            </v-card-text>
          </v-flex>
          <v-flex xs3 px-2 v-if="service_selected.image">
            <v-img :src="service_selected.image" width="100%"> </v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="pending_services"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.service.name }}</td>
                <td class="text-xs-center">
                  {{
                    props.item.student
                      ? props.item.student.full_name
                      : props.item.user.name
                  }}
                </td>
                <td class="text-xs-center">
                  ${{ formatNumber(props.item.service.price) }}
                </td>
                <td class="text-xs-center">{{ props.item.quantity }}</td>
                <td class="text-xs-center">
                  {{
                    formatNumber(
                      props.item.payment &&
                        props.item.payment.platform_payment_total
                    )
                  }}
                </td>
                <td class="text-xs-center">
                  <span v-if="props.item.needs_payment == 1">
                    {{ props.item.payment.payment_type }}
                  </span>
                  <span v-else>
                    Sin pago
                  </span>
                </td>
                <td class="text-xs-center">
                  <span v-if="props.item.needs_payment == 1">
                    {{
                      $t(
                        `enrollments.payment_status.${props.item.payment.payment_state}`
                      )
                    }}
                  </span>
                  <span v-else>
                    Agregado
                  </span>
                </td>
                <td class="text-xs-center">
                  <div v-if="props.item.needs_payment == 1">
                    <v-btn
                      v-if="
                        props.item.payment.payment_state !== 'APPROVED' &&
                          props.item.payment.payment_state !== 'OK'
                      "
                      color="error"
                      @click="cancel(props.item.id)"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      :loading="validate_btn_loading == props.item.payment_id"
                      :disabled="validate_btn_loading == props.item.payment_id"
                      v-if="props.item.payment.payment_state === 'PENDING'"
                      color="info"
                      @click="validatePayment(props.item.payment.id)"
                      >Validar pago</v-btn
                    >
                    <v-btn
                      v-if="
                        props.item.payment.payment_state !== 'APPROVED' &&
                          props.item.payment.payment_state !== 'OK' &&
                          props.item.payment.payment_state !== 'PENDING'
                      "
                      color="error"
                      outline
                      @click="
                        paymentProof(
                          props.item.payment,
                          props.item.service.name,
                          props.item.quantity,
                          props.item.token,
                          props.item.service.format,
                          props.item.service.image
                        )
                      "
                      >Comprobante</v-btn
                    >
                    <v-btn
                      v-if="
                        props.item.payment.payment_state === 'APPROVED' ||
                          props.item.payment.payment_state === 'OK'
                      "
                      color="success"
                      @click="
                        paymentProof(
                          props.item.payment,
                          props.item.service.name,
                          props.item.quantity,
                          props.item.token,
                          props.item.service.format,
                          props.item.service.image
                        )
                      "
                      >Ver comprobante</v-btn
                    >
                    <v-btn
                      v-if="
                        (props.item.payment.payment_state === 'APPROVED' ||
                          props.item.payment.payment_state === 'OK') &&
                          props.item.service.has_next_step == 1
                      "
                      @click="
                        nextStepConfirmation(
                          props.item.id,
                          props.item.service.next_step,
                          props.item.service.next_step_name
                        )
                      "
                      color="secondary"
                    >
                      {{ props.item.service.next_step_name }}
                    </v-btn>
                    <v-btn
                      v-if="
                        props.item.handles_format == 'digital' &&
                        props.item.status == 1
                      "
                      color="primary"
                      @click="showDocument(props.item)"
                      :disabled="documentDisabled(props.item.created_at)"
                      >Descargar Documento
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn
                      v-if="props.item.service.has_next_step == 1"
                      @click="
                        nextStepConfirmation(
                          props.item.id,
                          props.item.service.next_step,
                          props.item.service.next_step_name
                        )
                      "
                      color="secondary"
                    >
                      {{ props.item.service.next_step_name }}
                    </v-btn>
                    <v-btn
                      v-if="
                        props.item.handles_format == 'digital' &&
                        props.item.status == 1
                      "
                      color="primary"
                      @click="showDocument(props.item)"
                      :disabled="documentDisabled(props.item.created_at)"
                      >Descargar Documento
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap justify-center align-center mb-3 mt-2>
          <v-flex xs1>
            <v-img
              contain
              :src="`${appUrl}/storage/img/payment/pse-min.jpg`"
            ></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img
              contain
              :src="`${appUrl}/storage/img/payment/visa-min.webp`"
            ></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img
              contain
              :src="`${appUrl}/storage/img/payment/Mastercard-min.jpg`"
            ></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img
              contain
              :src="`${appUrl}/storage/img/payment/diners-min.jpg`"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="payment_dialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline primary white--text" primary-title>
          {{ $t("payments.payment_text_title") }}
        </v-card-title>

        <v-card-text v-html="$t('payments.payment_text')"> </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="payment_detail_dialog" width="350" persistent>
      <payment-proof
        :payment="payment_to_show"
        :payment_detail="payment_detail"
        :payment_quantity="payment_quantity"
        :payment_token="payment_token"
        :payment_format="payment_format"
        :payment_image="payment_image"
      >
      </payment-proof>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn color="primary" @click="payment_detail_dialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="document_dialog" width="835" persistent>
      <digital-doc
        :document="document_to_show"
        :template="template_to_show"
      >
      </digital-doc>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn color="primary" @click="document_dialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="go_dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="headline"
          >¿ Desea ir a {{ next_step_name }} ?</v-card-title
        >
        <v-card-text>
          Si desea ir a <strong>{{ next_step_name }}</strong
          >, debe completar la acción inmediatamente.
        </v-card-text>
        <v-card-text>
          Si ahora no le es posible completar
          <strong>{{ next_step_name }}</strong
          >, puede volver a esta página en otro momento y este se encontrará
          disponible.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outline @click="go_dialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="primary darken-1" outline @click="goToNextStep">{{
            next_step_name
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import paymentProof from "./../../payment/proof";
import digitalDoc from "./digital_document";
import moment from 'moment';
export default {
  name: "services-buy-view",
  components: {
    "payment-proof": paymentProof,
    "digital-doc": digitalDoc
  },
  data() {
    return {
      appUrl: window.config.appUrl,
      all_services: [],
      services: [],
      doc_templates: [],
      service: "",
      languages: [
        { value: "es", text: "Español" },
        { value: "en", text: "Inglés" }
      ],
      handles_language: "",
      formats: [
        { value: "digital", text: "Digital" },
        { value: "physical", text: "Físico" }
      ],
      handles_format: "",
      service_selected: {},
      payment_dialog: false,
      loading_btn: false,
      headers: [
        { text: "Nombre", align: "center", value: "service.name" },
        { text: "Usuario", align: "center", value: "service.user.name" },
        { text: "Precio", align: "center", value: "service.price" },
        { text: "Cantidad", align: "center", value: "service.quantity" },
        {
          text: "Total",
          align: "center",
          value: "payment.platform_payment_total"
        },
        { text: "Metodo", align: "center", value: "payment.payment_type" },
        { text: "Estado", align: "center", value: "payment.payment_state" },
        { text: "Acciones", align: "center", value: "actions" }
      ],
      pending_services: [],
      id_pago: null,
      validate_btn_loading: false,
      payment_detail_dialog: false,
      document_dialog: false,
      payment_to_show: {},
      document_to_show: {},
      template_to_show: {},
      payment_detail: "",
      payment_quantity: 1,
      payment_token: "",
      payment_format: "",
      payment_image: "",
      go_dialog: false,
      user_service_id: "",
      next_step: "",
      next_step_name: "",
      student: "",
      quantity: 1,
      students: [],
      all_students: [],
      user_name: "",
      portfolio: [],
      isInPortfolio: false,
      invalidQuantity: false,
      notAvailable: false
    };
  },
  created() {
    this.init();
    const idPago = this.$route.query.idPago;
    this.id_pago = idPago;
  },
  watch: {
    service(newValue, oldValue) {
      if (newValue) {
        this.service_selected = this.all_services.find(
          service => service.id == newValue
        );
        this.service_selected.total_price = this.service_selected.price;
        this.quantity = 1;

        this.students = // [
          // { value: '0-000', text: `FAMILIA ${this.user_name}` }
          // ].concat(
          this.all_students
            .filter(student => {
              let pass = true;
              if (this.service_selected.to_spesific_school == 1) {
                if (student.school_id != this.service_selected.school) {
                  pass = false;
                }
              }

              if (this.service_selected.to_spesific_grades == 1) {
                if (
                  !this.service_selected.grades
                    .split(", ")
                    .includes(student.grade_level)
                ) {
                  pass = false;
                }
              }
              return pass;
            })
            .filter(student => {
              let pass = true;
              if (this.service_selected.one_payment == 0) {
                return true;
              }

              student.services_paid.forEach(service_paid => {
                if (service_paid.service_id === this.service_selected.id) {
                  pass = false;
                }
              });

              return pass;
            })
            .filter(student => {
              let pass = true;
              if (this.service_selected.has_students == 1) {
                pass = false;
                this.service_selected.students.forEach(serviceStudent => {
                  if (serviceStudent.student_id == student.id) {
                    pass = true;
                  }
                });
              }
              return pass;
            })
            .map(student => {
              return {
                value: `${student.id}-${student.siesa_sucursal}`,
                text:
                  !student.siesa_sucursal ||
                  !student.siesa_tercero_id ||
                  !student.siesa_tercero_id_type
                    ? student.full_name + " (Faltan datos del estudiante)"
                    : student.full_name,
                grade_level: student.grade_level,
                school_id: student.school_id,
                siesa_sucursal: student.siesa_sucursal,
                siesa_tercero_id: student.siesa_tercero_id,
                siesa_tercero_id_type: student.siesa_tercero_id_type,
                disabled:
                  !student.siesa_sucursal ||
                  !student.siesa_tercero_id ||
                  !student.siesa_tercero_id_type
              };
            });
        // )

        return;
      }
      this.service_selected = {};
    },
    student(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.validatePortfolio();
      }
    },
    quantity(newValue, oldValue) {
      if (
        this.service_selected.limit_services == 1 &&
        this.service_selected.available_services < newValue
      ) {
        this.notAvailable = true;
      } else if (
        newValue <= 0 ||
        newValue > this.service_selected.max_services
      ) {
        this.invalidQuantity = true;
      } else {
        if (newValue !== oldValue) {
          this.service_selected.total_price =
            this.service_selected.price * newValue;
        }
        this.invalidQuantity = false;
        this.notAvailable = false;
      }
    }
  },
  computed: {
    canGoToService() {
      return false;
    }
  },
  methods: {
    init() {
      axios.get("/api/school/services/available").then(resp => {
        if (resp.status === 200) {
          const services = Object.values(resp.data.services);
          this.all_services = services;
          this.pending_services = resp.data.pending_services;
          this.all_students = resp.data.students;
          this.user_name = resp.data.user_name;
          this.portfolio = resp.data.portfolio;

          if (this.id_pago) {
            this.validateCallbackPayment();
          }

          services.map(service => {
            this.services.push({ value: service.id, text: service.name });
          });
        }
      });
      axios.get("/api/school/services/templates").then(resp => {
        if (resp.status === 200) {
          this.doc_templates = resp.data;
        }
      });
    },
    formatNumber(number) {
      if (!number || typeof number === "undefined") {
        return 0;
      } else {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    async validForm() {
      return await this.$validator.validateAll();
    },
    validatePortfolio() {
      const student = this.students.find(
        student => student.value == this.student
      );
      this.isInPortfolio = false;
      this.isInPortfolio =
        this.portfolio.filter(
          portfolio => portfolio.id_sucursal == student.siesa_sucursal
        ).length > 0;
    },
    payPse() {
      const service_id = this.service;
      const total = this.service_selected.total_price;
      const student = this.student;
      const quantity = this.quantity;
      const handles_language = this.handles_language;
      const handles_format = this.handles_format;
      //this.loading_btn = true;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          axios
            .post("/api/school/service/pay/pse", {
              service_id,
              total,
              student,
              quantity,
              handles_language,
              handles_format
            })
            .then(resp => {
              if (resp.status === 200) {
                this.payment_dialog = true;
                setTimeout(() => {
                  window.location = resp.data.urlRedirect;
                }, 5000);
              } else {
                this.$store.dispatch("responseMessage", {
                  type: "error",
                  text: this.$t("extracurriculares.pay_reserve.payment_error"),
                  title: this.$t("error_alert_text"),
                  modal: true
                });
              }
              this.loading_btn = false;
            })
            .catch(error => {
              console.log(error);
              this.loading_btn = false;
            });
        }
      });
    },
    payTc() {
      const service_id = this.service;
      const total = this.service_selected.total_price;
      const student = this.student;
      const quantity = this.quantity;
      const handles_language = this.handles_language;
      const handles_format = this.handles_format;
      //this.loading_btn = true;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          axios
            .post("/api/school/service/pay/tc", {
              service_id,
              total,
              student,
              quantity,
              handles_language,
              handles_format
            })
            .then(resp => {
              if (resp.status === 200) {
                if (resp.data.error) {
                  this.$store.dispatch("responseMessage", {
                    type: "error",
                    text: resp.data.message,
                    title: this.$t("error_alert_text"),
                    modal: true
                  });
                  this.loading_btn = false;
                  return;
                }
                this.payment_dialog = true;
                setTimeout(() => {
                  window.location = resp.data.url;
                }, 5000);
              } else {
                this.$store.dispatch("responseMessage", {
                  type: "error",
                  text: this.$t("extracurriculares.pay_reserve.payment_error"),
                  title: this.$t("error_alert_text"),
                  modal: true
                });
              }
              this.loading_btn = false;
            })
            .catch(error => {
              this.loading_btn = false;
            });
        }
      });
    },
    getService() {
      const service_id = this.service;
      const student = this.student;
      const quantity = this.quantity;

      const handles_language = this.handles_language;
      const handles_format = this.handles_format;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          axios
            .post("/api/school/service/pay/no_pay", {
              service_id,
              student,
              quantity,
              handles_language,
              handles_format
            })
            .then(resp => {
              if (resp.status === 200) {
                this.service = "";
                this.init();
              }
            })
            .catch(error => {
              this.loading_btn = false;
            });
        }
      });
    },
    cancel(user_service_id) {
      axios
        .post("/api/school/service/cancel", { user_service_id })
        .then(resp => {
          if (resp.status === 200) {
            this.pending_services = this.pending_services.filter(
              user_service => user_service.id !== user_service_id
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    validatePayment(payment_id) {
      this.validate_btn_loading = payment_id;
      axios
        .post("/api/school/service/validate_payment", { payment_id })
        .then(resp => {
          if (resp.status === 200) {
            this.init();
            this.$store.dispatch("fetchMenu");
            this.validate_btn_loading = false;
          }
        })
        .catch(error => {
          this.validate_btn_loading = false;
          console.log(error);
        });
    },
    validateCallbackPayment() {
      const idPago = this.id_pago;
      this.id_pago = null;
      const serviceToValidate = this.pending_services.find(
        service => service.payment.payment_id == idPago
      );
      this.validatePayment(serviceToValidate.payment_id);
    },
    paymentProof(payment, service_name, quantity, token, format, image) {
      this.payment_detail_dialog = true;
      this.payment_to_show = payment;
      this.payment_detail = service_name;
      this.payment_quantity = quantity;
      this.payment_token = token;
      this.payment_format = format;
      this.payment_image = image;
    },
    showDocument(document) {
      let status = 0
      if (document.student.enroll_status == 0) {
        status = 1
      }
      
      let template = this.doc_templates.find(
        doc => doc.language == document.handles_language && doc.student_status == status && doc.service_id == document.service_id
      );

      if (!template) {
        return
      }
      
      this.document_dialog = true;
      this.document_to_show = document;

      moment.locale(document.handles_language)
      const today = moment().format('MMMM D YYYY')

      let pronoun = 'He/She'
      let grade_level = document.student.grade_level
      let grade_level2 = document.student.grade_level

      if (document.student.gender == 'M') {
        pronoun = 'He'
      } else if (document.student.gender == 'F') {
        pronoun = 'She'
      }

      if (document.student.grade_level == 'K4') {
        grade_level2 = 'Pre Jardín'
      } else if (document.student.grade_level == 'K5') {
        grade_level2 = 'Jardín'
      } else if (document.student.grade_level == '1') {
        grade_level2 = 'Transición'
      } else if (document.student.grade_level == '99') {
        grade_level = '12'
        grade_level2 = '11'
      } else {
        grade_level2 = parseInt(grade_level) - 1
      }

      const replace = {
        "{{date}}": today,
        "{{full_name}}": document.student.full_name,
        "{{pronoun}}": pronoun,
        "{{grade_level}}": grade_level,
        "{{grade_level2}}": grade_level2,
        "{{entry_date}}": new Date(document.student.entry_date).getFullYear(),
        "{{exit_date}}": new Date(document.student.exit_date).getFullYear(),
        "{{signature}}": "<img src='" + template.signature + "' width='180'>"
      };
      Object.keys(replace).forEach((key) => {
        template.text = template.text.replaceAll(key, replace[key]);
      });

      this.template_to_show = template;

    },
    nextStepConfirmation(user_service_id, next_step, next_step_name) {
      this.go_dialog = true;
      this.user_service_id = user_service_id;
      this.next_step = next_step;
      this.next_step_name = next_step_name;
    },
    goToNextStep() {
      const user_service_id = this.user_service_id;
      const next_step = this.next_step;
      axios
        .post("/api/school/service/use", { user_service_id, next_step })
        .then(resp => {
          if (resp.status === 200) {
            this.$router.push({ path: next_step });
          }
        })
        .catch(error => console.log(error));
    },
    documentDisabled(date) {
      const monthAfter = moment(date).add(1, 'months')
      if (moment().isAfter(monthAfter)) {
        return true
      } else {
        return false
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/school/services/buy.vue